import { configConstants } from '_constants';
import { configService } from '_services';
import { session, common } from '_helpers';
import alertActions from './alert.actions';

const getConfig = (machineID) => async (dispatch) => {
  await dispatch(request());
  try {
    const config = await configService.getConfig(machineID);
    await dispatch(success(config));
  } catch (error) {
    session.checkSession(error);
    await dispatch(failure(error.message));
    await dispatch(alertActions.error(error.message));
  }
  function request() {
    return { type: configConstants.CONFIG_REQUEST };
  }
  function success(config) {
    return { type: configConstants.CONFIG_SUCCESS, config };
  }
  function failure(error) {
    return { type: configConstants.CONFIG_FAILURE, error };
  }
};

const getSetup = (machineID) => async (dispatch) => {
  await dispatch(request());
  try {
    const setup = await configService.getSetup(machineID);
    await dispatch(success(setup));
  } catch (error) {
    session.checkSession(error);
    await dispatch(failure(error.message));
    await dispatch(alertActions.error(error.message));
  }

  function request() {
    return { type: configConstants.CONFIG_SETUP_REQUEST };
  }
  function success(setup) {
    return { type: configConstants.CONFIG_SETUP_SUCCESS, setup };
  }
  function failure(error) {
    return { type: configConstants.CONFIG_SETUP_FAILURE, error };
  }
};

const updConfig = (machineID, config) => async (dispatch) => {
  await dispatch(request());
  try {
    const result = await configService.update(machineID, config);
    if (result && result.result) {
      await dispatch(success(config));
      await dispatch(alertActions.success('Machine Updated Successfully'));
    } else {
      const errorMessage = common.getErrorMessage(result.message);
      await dispatch(failure(errorMessage));
      await dispatch(alertActions.error(errorMessage));
    }
  } catch (error) {
    session.checkSession(error);
    await dispatch(failure(error.message));
    await dispatch(alertActions.error(error.message));
  }

  function request() {
    return { type: configConstants.CONFIG_UPD_REQUEST };
  }
  function success(config) {
    return { type: configConstants.CONFIG_UPD_SUCCESS, config };
  }
  function failure(error) {
    return { type: configConstants.CONFIG_UPD_FAILURE, error };
  }
};

const validate = (machineID, config) => async (dispatch) => {
  await dispatch(request());
  try {
    const result = await configService.validate(machineID, config);
    if (result.result) {
      await dispatch(success());
      await dispatch(alertActions.success('Agent Configuration Validated'));
    } else {
      const errorMessage = common.getErrorMessage(result.message);
      await dispatch(failure(errorMessage));
      await dispatch(alertActions.error(errorMessage));
    }
  } catch (error) {
    session.checkSession(error);
    await dispatch(failure(error.message));
    await dispatch(alertActions.error(error.message));
  }

  function request() {
    return { type: configConstants.CONFIG_VAL_REQUEST };
  }
  function success() {
    return { type: configConstants.CONFIG_VAL_SUCCESS };
  }
  function failure(error) {
    return { type: configConstants.CONFIG_VAL_FAILURE, error };
  }
};

const configActions = {
  getConfig,
  updConfig,
  getSetup,
  validate,
};

export default configActions;
